import { ADD_ITEM_TO_CART_FAILURE, ADD_ITEM_TO_CART_REQUEST, ADD_ITEM_TO_CART_SUCCESS, GET_CART_FAILURE, GET_CART_REQUEST, GET_CART_SUCCESS, REMOVE_CART_ITEM_FAILURE, REMOVE_CART_ITEM_REQUEST, REMOVE_CART_ITEM_SUCCESS, UPDATE_CART_ITEM_FAILURE, UPDATE_CART_ITEM_REQUEST, UPDATE_CART_ITEM_SUCCESS } from "./ActionType"

const items = localStorage.getItem('cartItems') !== null ? JSON.parse(localStorage.getItem('cartItems')) : [];
const totalQuantity = localStorage.getItem('totalQuantity') !== null ? JSON.parse(localStorage.getItem('totalQuantity')) : 0;
const totalAmount = localStorage.getItem('totalAmount') !== null ? JSON.parse(localStorage.getItem('totalAmount')) : 0;


const initialState = {
    loading: false,
    error: null,
    cartItems: items,
    totalQuantity: totalQuantity,
    totalAmount: totalAmount,

}
export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ITEM_TO_CART_REQUEST:
            return { ...state, loading: true, error: null }
        case ADD_ITEM_TO_CART_SUCCESS:
            {
                const newItem = action.payload;
                const existingItem = state.cartItems.find((item) => item.productId === newItem.productId && item.color === newItem.color && item.size === newItem.size)

                if (existingItem) {
                    existingItem.quantity = existingItem.quantity + 1;


                }
                else
                    state.cartItems.push(newItem)


                state.totalQuantity = state.totalQuantity + 1;
                state.totalAmount = state.totalAmount + newItem.unitPrice;
                localStorage.setItem('cartItems', JSON.stringify(state.cartItems.map(item => item)))
                localStorage.setItem('totalQuantity', JSON.stringify(state.totalQuantity))
                localStorage.setItem('totalAmount', JSON.stringify(state.totalAmount))

                return { ...state, loading: false, error: null }

            }

        case ADD_ITEM_TO_CART_FAILURE:
            return { ...state, loading: false, error: action.payload }
        case GET_CART_REQUEST:
            return { ...state, loading: true, error: null }
        case GET_CART_SUCCESS:
            return { ...state, cartItems: action.payload.cartItems, cart: action.payload, loading: false }
        case GET_CART_FAILURE:
            return { ...state, loading: false, error: action.payload }
        case REMOVE_CART_ITEM_REQUEST:
        case UPDATE_CART_ITEM_REQUEST:
            return { ...state, loading: true, error: null }
        case REMOVE_CART_ITEM_SUCCESS:
            {

                const newItem = action.payload;
                const existingItem = state.cartItems.find((item) => (item.productId === newItem.productId && item.color === newItem.color && item.size === newItem.size));

                const newItems = state.cartItems.filter((item) => item.productId !== newItem.productId || item.color !== newItem.color|| item.size !== newItem.size)

              


                if (existingItem) {
                    state.cartItems = newItems;
                    if (state.cartItems.length===0) {
                        state.totalQuantity = 0;
                        state.totalAmount = 0;
                    }
                    else {
                        state.totalQuantity = state.totalQuantity - existingItem.quantity;
                        state.totalAmount = state.totalAmount - (existingItem.unitPrice * existingItem.quantity);
                    }

                    localStorage.setItem('cartItems', JSON.stringify(state.cartItems.map(item => item)))
                    localStorage.setItem('totalQuantity', JSON.stringify(state.totalQuantity))
                    localStorage.setItem('totalAmount', JSON.stringify(state.totalAmount))
                }
                return { ...state, loading: false, error: null }
            }

        case UPDATE_CART_ITEM_SUCCESS:
            {
                const newItem = action.payload;
                const existingItem = state.cartItems.find((item) => item.productId === newItem.productId && item.color === newItem.color && item.size === newItem.size)
                if (existingItem.quantity === 1 && newItem.quantity < 1) {
                    const newItems = state.cartItems.filter(item => (item.productId !== newItem.productId, item.color !== newItem.color, item.size !== newItem.size))
                    if (existingItem) {
                        state.cartItems = newItems;
                        if (state.cartItems.length===0) {
                            state.totalQuantity = 0;
                            state.totalAmount = 0;
                        }
                        else {
                            state.totalQuantity = state.totalQuantity - existingItem.quantity;
                            state.totalAmount = state.totalAmount - (existingItem.unitPrice * existingItem.quantity);
                        }
                        localStorage.setItem('cartItems', JSON.stringify(state.cartItems.map(item => item)))
                        localStorage.setItem('totalQuantity', JSON.stringify(state.totalQuantity))
                        localStorage.setItem('totalAmount', JSON.stringify(state.totalAmount))
                    }
                }
                else {
                    existingItem.quantity = existingItem.quantity + newItem.quantity;
                    state.totalQuantity = state.totalQuantity + newItem.quantity;
                    state.totalAmount = state.totalAmount + newItem.unitPrice;
                    localStorage.setItem('cartItems', JSON.stringify(state.cartItems.map(item => item)))
                    localStorage.setItem('totalQuantity', JSON.stringify(state.totalQuantity))
                    localStorage.setItem('totalAmount', JSON.stringify(state.totalAmount))

                }
                return { ...state, loading: false, error: null }
            }
        case REMOVE_CART_ITEM_FAILURE:
        case UPDATE_CART_ITEM_FAILURE:
            return { ...state, error: action.payload, loading: false }
        default:
            return state;
    }
}